import { reportTrackerFailure } from 'src/dataLayer/remoteData/rollbar/reportAPIErrors.ts';
import emitEvent from './emitEvent';
import validateEventProps from './validateEventProps';
import validateTrackingUuid from './validateTrackingUuid';
import { LOCALE } from 'src/dataLayer/env';

export default ({ name, version, requiresTrackingUuid, getCalltimePayload }) => (payload) => {
  const { learnLang } = payload;
  validateEventProps({ name, version, learnLang });
  if (requiresTrackingUuid && validateTrackingUuid() === false) return;

  emitEvent({
    name,
    version,
    payload: {
      locale: LOCALE,
      ...(learnLang && { learn_language_alpha3: learnLang }),
      ...getCalltimePayload(payload)
    },
    error: (error) => reportTrackerFailure(error, name, payload)
  });
};
